var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-left",class:_vm.extraClasses,attrs:{"scope":"row"}},[_vm._t("heading",function(){return [_vm._v(" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }